import { render, staticRenderFns } from "./Cotree.vue?vue&type=template&id=68dc11f4&"
import script from "./Cotree.vue?vue&type=script&lang=js&"
export * from "./Cotree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports